module.exports = __webpack_public_path__ + "static/media/color_02.cb400525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/color_02.jpg
// module id = 378
// module chunks = 0